// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Wechat from '@spero/h5-wechat-sdk'
import App from './app'
import router from './router'
import store from './store'
import VConsole from 'vconsole'

import config from '@/config'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// styles
import 'flexboxgrid/dist/flexboxgrid.min.css'
import './styles.styl'

// mixins
import global from '@/mixins/global'
import BGCOVER from '@/mixins/avatar-mixin'
import login from '@/mixins/login'
import jsBridge from '@/mixins/js-bridge'
import openInstallMixin from '@spero/spero-utils/src/mixins/openinstall-mixin'
// import hrefParams from '@/mixins/href-params'

// component
import Message from '@spero/spero-utils/src/components/toast-message'
import Layer2 from '@spero/spero-utils/src/components/layer2'

// apis
import AuthApi from '@/apis/auth-api'
import LokiApi from '@/apis/loki-api'
import UltronApi from '@/apis/ultron-api'
import SaApi from '@/apis/sa-api'
import SmsApi from './apis/sms-api'
import RootApi from './apis/root-api'
import AdminApi from './apis/admin-api'
import JindashiApi from '@/apis/jindashi-api'

import VueVideoPlayer from 'vue-video-player'
import { EmojiPickerPlugin } from 'vue-emoji-picker'

import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
import JWEIXIN_CONFIG from '@/constants/jweixin-config'

import VueClipboard from 'vue-clipboard2'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

Vue.use(ViewUI)
Vue.use(VueVideoPlayer)

const BrowserLogger = require('alife-logger')
const __bl = BrowserLogger.singleton(
  {
    pid: 'bzskmg4rzq@ad79476eb0e07ce',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    disabled: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
    environment: process.env.ENV === 'production' ? 'prod' : process.env.ENV === 'preview' ? 'pre' : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'local' : 'daily'
  }
)
console.log(__bl)
Vue.prototype.$__bl = __bl
Vue.use(MintUI)
Vue.use(EmojiPickerPlugin)
Vue.use(Message)
Vue.use(Layer2)
Vue.mixin(global)
Vue.mixin(jsBridge)
Vue.mixin(BGCOVER)
Vue.mixin(login)
Vue.mixin(openInstallMixin)
// Vue.mixin(hrefParams)

Vue.config.productionTip = false

// if (process.env.ENV !== 'production') {
//   const VConsole = require('./helpers/vconsole')
//   console.log('VConsole', VConsole)
// }

if (process.env.ENV !== 'production') {
  window.vconsole = new VConsole()
}

Vue.use(AuthApi)
Vue.use(LokiApi)
Vue.use(AdminApi)
Vue.use(SmsApi)
Vue.use(UltronApi)
Vue.use(SaApi, config.saApi)
Vue.use(RootApi)
Vue.use(Wechat)
Vue.use(VueClipboard)
Vue.use(JindashiApi)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  authApi: new AuthApi(config.authApi),
  adminApi: new AdminApi(config.adminApi),
  lokiApi: new LokiApi(config.lokiApi),
  ultronApi: new UltronApi(config.ultronApi),
  smsApi: new SmsApi(config.smsApi),
  rootApi: new RootApi(config.rootApi),
  jindashiApi: new JindashiApi(config.jindashiApi),
  wechat: new Wechat({
    debug: false,
    appId: 'wx5eb8abb782d660a9',
    state: '',
    authURL: config.ultronApi.baseURL + JWEIXIN_CONFIG.AUTH_PATH,
    signatureURL: config.ultronApi.baseURL + JWEIXIN_CONFIG.SIGNATURE_PATH,
    jsApiList: JWEIXIN_CONFIG.JS_API_LIST
  }),
  // saApi: new SaApi(config.saApi),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js